import { render, staticRenderFns } from "./TerminologyFacetTree.vue?vue&type=template&id=79cc73a4&scoped=true"
import script from "./TerminologyFacetTree.vue?vue&type=script&lang=js"
export * from "./TerminologyFacetTree.vue?vue&type=script&lang=js"
import style0 from "./TerminologyFacetTree.vue?vue&type=style&index=0&id=79cc73a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc73a4",
  null
  
)

export default component.exports